import { lazy } from 'react';
import { TabListEntityTouchpoints } from 'src/compass/pages/riskManagement/CustomersPage';
import { TabListToRouteList } from '../../util/TabListToRouteList';
import { ICONS } from '../navigationIcons';

const NavigatorPage = lazy(() => import('src/compass/pages/riskManagement/NavigatorPage'));
const InventoryPage = lazy(() => import('src/compass/pages/riskManagement/InventoryPage'));
const FeederIndexPage = lazy(() => import('src/compass/pages/riskManagement/FeederIndexPage'));
const LrpTypesCyComparisonPage = lazy(
  () => import('src/compass/pages/riskManagement/LrpTypesCyComparisonPage')
);

const SceReportsPage = lazy(() => import('src/compass/pages/riskManagement/SceReportsPage'));
const CustomersPage = lazy(() => import('src/compass/pages/riskManagement/CustomersPage'));
const SalesDashboardPage = lazy(() => import('src/compass/pages/riskManagement/SalesDashboardPage'));
const MyDashboardPage = lazy(() => import('src/compass/pages/riskManagement/MyDashboardPage'));
const LrpClaimsPage = lazy(() => import('src/compass/pages/riskManagement/LrpClaimsPage'));

export const RiskManagementMenu = [
  {
    menuTitle: 'Risk Management',
    path: 'riskmanagement',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'My Dashboard',
        path: 'mydashboard',
        element: <MyDashboardPage />,
        permission: 'MY_COMMISSIONS',
      },
      {
        title: 'LRP Claims',
        path: 'mycustomerclaims',
        element: <LrpClaimsPage />,
        permission: 'LRP_CLAIMS',
      },
      {
        title: 'Customers',
        path: 'customers',
        element: <CustomersPage />,
        permission: 'CUSTOMERS',
        children: TabListToRouteList(TabListEntityTouchpoints),
      },
      {
        title: 'Feeder Index',
        path: 'feederindex',
        element: <FeederIndexPage />,
        permission: 'FEEDER_INDEX',
      },
      {
        title: 'Inventory',
        path: 'inventory',
        element: <InventoryPage />,
        permission: 'INVENTORY',
      },
      {
        title: 'Navigator',
        path: 'navigator',
        element: <NavigatorPage />,
        permission: 'NAVIGATOR',
      },
      {
        title: 'Sales Dashboard',
        path: 'salesdashboard',
        element: <SalesDashboardPage />,
        permission: 'SALES_DASHBOARD',
      },
      {
        title: 'SCE Reports',
        path: 'scereports',
        element: <SceReportsPage />,
        permission: 'SCE_REPORTS',
      },
      {
        title: 'RMA Total LRP Head Counts',
        path: 'lrptypescycomparison',
        element: <LrpTypesCyComparisonPage />,
        permission: 'LRP_TYPES_CY_COMPARISON',
      },
    ],
  },
];
